import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' }
});

// Projects
export const getProjects = (category) => {
  const params = category && category !== 'all' ? { category } : {};
  return api.get('/projects', { params }).then(r => r.data);
};

export const getFeaturedProjects = () => 
  api.get('/projects', { params: { featured: true } }).then(r => r.data);

export const getHomepageProjects = () => 
  api.get('/projects', { params: { show_on_homepage: true } }).then(r => r.data);

export const getProject = (slug) => 
  api.get(`/projects/${slug}`).then(r => r.data);

// Equipment
export const getEquipment = (filters = {}) => {
  const params = {};
  if (filters.category && filters.category !== 'all') params.category = filters.category;
  if (filters.brand) params.brand = filters.brand;
  if (filters.spec) params.spec = filters.spec;
  if (filters.use_case) params.use_case = filters.use_case;
  return api.get('/equipment', { params }).then(r => r.data);
};

// Clients
export const getClients = () => api.get('/clients').then(r => r.data);

// Articles
export const getLatestArticles = (limit = 3) => 
  api.get('/journal/articles', { params: { limit, status: 'published' } }).then(r => r.data);

// Inquiries
export const submitInquiry = (data) => api.post('/inquiries', data).then(r => r.data);

// Success Stories
export const getSuccessStories = () => api.get('/success-stories').then(r => r.data);
export const getSuccessStory = (slug) => api.get(`/success-stories/${slug}`).then(r => r.data);

export default api;
